<template>
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M6.00016 8.63748L3.92516 9.88748C3.8335 9.94581 3.73766 9.97081 3.63766 9.96247C3.53766 9.95414 3.45016 9.92081 3.37516 9.86248C3.30016 9.80414 3.24183 9.73131 3.20016 9.64398C3.1585 9.55664 3.15016 9.45864 3.17516 9.34998L3.72516 6.98748L1.88766 5.39998C1.80433 5.32498 1.75233 5.23948 1.73166 5.14348C1.711 5.04748 1.71716 4.95381 1.75016 4.86248C1.78316 4.77114 1.83316 4.69614 1.90016 4.63748C1.96716 4.57881 2.05883 4.54131 2.17516 4.52498L4.60016 4.31248L5.53766 2.08748C5.57933 1.98748 5.644 1.91248 5.73166 1.86248C5.81933 1.81248 5.90883 1.78748 6.00016 1.78748C6.0915 1.78748 6.181 1.81248 6.26866 1.86248C6.35633 1.91248 6.421 1.98748 6.46266 2.08748L7.40016 4.31248L9.82516 4.52498C9.94183 4.54164 10.0335 4.57914 10.1002 4.63748C10.1668 4.69581 10.2168 4.77081 10.2502 4.86248C10.2835 4.95414 10.2898 5.04798 10.2692 5.14398C10.2485 5.23998 10.1963 5.32531 10.1127 5.39998L8.27516 6.98748L8.82516 9.34998C8.85016 9.45831 8.84183 9.55631 8.80016 9.64398C8.7585 9.73164 8.70016 9.80448 8.62516 9.86248C8.55016 9.92048 8.46266 9.95381 8.36266 9.96247C8.26266 9.97114 8.16683 9.94614 8.07516 9.88748L6.00016 8.63748Z"
			fill="currentColor"
			stroke-width=".3px"
			:stroke="strokeColor || null"
		/>
	</svg>
</template>
<script setup>
defineProps({
	strokeColor: String
})
</script>
